import { FileDownload } from '@mui/icons-material';
import { Checkbox, FormControlLabel, Button, RadioGroup, Radio } from '@mui/material';

import './TableControls.css';
import { TableControlsProps } from './TableControls.types';
import { PriceType } from '../..';

/**
 * Renders table control buttons and options for pricing tables
 * Includes export functionality, brand ordering, and discount visibility controls
 *
 * @param props - The component props
 * @returns JSX element containing table control interface
 */
export function TableControls({
  title,
  hideDiscounts,
  onHideDiscountsChange,
  onChangePriceTypes,
  priceTypes,
  onExport,
  onBrandOrder,
  showExport = true,
  showBrandOrder = true,
  showHideDiscounts = true,
  isMobile = false,
  exportLabel = 'Вивантажити роздрібні ціни',
  brandOrderLabel = 'Налаштувати бренди'
}: TableControlsProps) {
  return (
    <div className={`table-controls ${isMobile ? 'mobile-controls' : ''}`}>
      <div className="controls-left">
        {title && (
          <h2 className="section-title" style={{ margin: 0 }}>
            {title}
          </h2>
        )}
        {showExport && onExport && (
          <button className="export-btn" onClick={onExport}>
            <FileDownload />
            {!isMobile && exportLabel}
          </button>
        )}
        {showBrandOrder && onBrandOrder && (
          <Button
            variant="outlined"
            onClick={onBrandOrder}
            className="brand-order-btn"
            size={isMobile ? 'small' : 'medium'}
          >
            {isMobile ? 'Бренди' : brandOrderLabel}
          </Button>
        )}
      </div>

      <div className={`controls-right ${isMobile ? 'mobile-controls' : ''}`}>
        {priceTypes && onChangePriceTypes && (<RadioGroup row aria-labelledby={`$-label`} name="row-radio-buttons-group" onChange={onChangePriceTypes} value={priceTypes}>
          <FormControlLabel value={PriceType.MODE} control={<Radio />} label="Модна ціна" />
          <FormControlLabel value={PriceType.AVERAGE} control={<Radio />} label="Середня ціна" />
        </RadioGroup>)}
      

        {showHideDiscounts && onHideDiscountsChange && (
          <FormControlLabel
            control={<Checkbox checked={hideDiscounts} onChange={e => onHideDiscountsChange(e.target.checked)} />}
            label="Приховати знижки"
            className="hide-discounts"
          />
        )}
      </div>

    </div>
  );
}
